import React, { useState, useCallback } from 'react'
import { Typography } from 'react-components'
import { useTranslation } from '../../../hooks/locale'
import { VirtualTourIcon, VirtualTourTagContainer, VirtualTourTextContainer } from './styles'
import { Image } from '../../property-details/expose-gallery/gallery/types'
import VirtualTourModal from './virtual-tour-modal'

interface Props {
    video?: Image
    handleCtaClick?: (e: React.MouseEvent) => void
    isSmallVersion?: boolean
}

const VirtualTourTag: React.FC<Props> = ({ video, handleCtaClick, isSmallVersion = false }) => {
    const { t } = useTranslation()
    const [isOverlayOpen, setOverlay] = useState(false)

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            if (video) {
                e.stopPropagation()
                setOverlay(true)
            }
        },
        [video],
    )

    const handleClose = useCallback(() => {
        setOverlay(false)
    }, [])

    return (
        <>
            <VirtualTourTagContainer onClick={handleClick} $isSmall={isSmallVersion}>
                <VirtualTourIcon />
                <VirtualTourTextContainer>
                    <Typography variant={isSmallVersion ? 'overline' : 'caption'} fontWeight="regular" lineHeight={1}>
                        {t('gallery.virtual')}
                    </Typography>
                    <Typography variant={isSmallVersion ? 'caption' : 'subtitle2'} fontWeight="semiBold" lineHeight={1}>
                        {t('gallery.tour')}
                    </Typography>
                </VirtualTourTextContainer>
            </VirtualTourTagContainer>
            {isOverlayOpen && !!video && (
                <VirtualTourModal
                    isOpen={isOverlayOpen}
                    onClose={handleClose}
                    video={video}
                    handleCtaClick={handleCtaClick}
                />
            )}
        </>
    )
}

export default VirtualTourTag
